import { useIntl } from '@/intl'
import { AccoList } from '@/scopes/common/components/AccoLister/AccoList'
import { AccoListLoading } from '@/scopes/common/components/AccoLister/AccoList/AccoListLoading'
import { useOnScreen } from '@/scopes/common/components/hooks/useOnScreen'
import {
  useRecommendedAccos,
  useSendRecommendationsInViewportEvent,
  useSessionRecorder,
} from '@/scopes/products/pages/components/RecommendedAccos/hooks'
import { createSearchRecommendationClickEvent } from '@/scopes/search/search/domain/analytics'
import { useEffect, useRef, useState } from 'react'
import { styled } from 'styled-components'
import { HeadingLabel } from '../HeadingLabel'

const Container = styled.div``

export default function RecommendedAccos() {
  const intl = useIntl()
  const recommendedAccosRef = useRef(null)
  const [hasBeenInView, setHasBeenInView] = useState(false)
  useSendRecommendationsInViewportEvent(recommendedAccosRef)
  useSessionRecorder()
  const componentInView = useOnScreen(recommendedAccosRef)
  const { isLoading, recommendedAccos } = useRecommendedAccos()

  useEffect(() => {
    if (componentInView)
      setHasBeenInView(true)
  }, [componentInView])

  return (
    <Container ref={recommendedAccosRef}>
      {(isLoading || recommendedAccos) && <HeadingLabel text={intl.formatMessage({ id: 'recommended_accos_title' })} />}
      {hasBeenInView && isLoading
        ? (
            <AccoListLoading />
          )
        : (
            <AccoList
              accos={recommendedAccos}
              nextButtonLabel={intl.formatMessage({ id: 'recommended_accos_carousel_next_button_aria_label' })}
              prevButtonLabel={intl.formatMessage({ id: 'recommended_accos_carousel_prev_button_aria_label' })}
              onClickEventCallback={createSearchRecommendationClickEvent}
            />
          )}
    </Container>
  )
}
